import React, {ReactElement, useEffect, useState} from 'react';
import {Button} from '@customink/pigment-react';
import signaler, {FeatureFlags} from '../../vendor/signaler';

import './index.scss';

type SignalProviderProps = {
  featureSettings: FeatureFlags;
};

type FeatureFlagState = {
  [key: string]: string;
};

const SignalProvider: React.FC<SignalProviderProps> = ({
  featureSettings
}: SignalProviderProps): ReactElement => {
  const [featureFlags, setFeatureFlags] = useState({} as FeatureFlagState);

  useEffect(() => {
    signaler.featureFlags().then((flags: any) => {
      setFeatureFlags(flags);
    });
  }, []);

  const changeFlag = (featureName: string, target: any) => {
    const {value} = target;
    signaler.setFeatureFlag(featureName, value);
    const flags = {...featureFlags, [featureName]: value};
    setFeatureFlags(flags);
  };

  const renderFlags = (flagNames: string[]) => {
    return flagNames.map(flagName => {
      return (
        <option
          data-testid="featureFlag-select-option"
          key={flagName}
          value={flagName}>
          {flagName}
        </option>
      );
    });
  };

  const renderFeatures = () => {
    return Object.keys(featureSettings).map(featureName => {
      const {flags} = featureSettings[featureName];
      const value = featureFlags[featureName];
      return (
        <div key={featureName} className="FeatureFlags-feature">
          <h3>{featureName}</h3>
          <select
            data-testid="featureFlag-select"
            value={value}
            onChange={e => changeFlag(featureName, e)}>
            <option data-testid="featureFlag-select-option" key="none" value="">
              (none)
            </option>
            {renderFlags(Object.keys(flags))}
          </select>
        </div>
      );
    });
  };

  return (
    <div className="FeatureFlags">
      <h1>Feature Flags</h1>
      {Object.keys(featureFlags).length !== 0 ? renderFeatures() : ''}
      <a className="FeatureFlags-close" href="/">
        <Button
          size="small"
          onClick={() => {
            'do nothing';
          }}>
          Close
        </Button>
      </a>
    </div>
  );
};

export default SignalProvider;
